// extracted by mini-css-extract-plugin
export default {"container":"OrderSummary_container__HDcMe","subContainer":"OrderSummary_subContainer__Kv8qR","leftArrow":"OrderSummary_leftArrow__ZV6tT"};